"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constant = require("@airasia/phoenix-components/components/Theme/constant");

var _constant2 = require("../constant");

var _default = {
  PropTypes: {
    dateFormatData: _propTypes.default.shape({
      date: _propTypes.default.shape({
        noYear: _propTypes.default.string,
        fullWithDay: _propTypes.default.string,
        noDay: _propTypes.default.string,
        abbreviate: _propTypes.default.string,
        general: _propTypes.default.string
      })
    }),
    lowestFareLabel: _propTypes.default.string,
    noFareLabel: _propTypes.default.string,
    currency: _propTypes.default.string,
    viewType: _propTypes.default.string,
    theme: _propTypes.default.string,
    confirmLabel: _propTypes.default.string,
    resetLabel: _propTypes.default.string,
    isFareLoaded: _propTypes.default.bool,
    isPartialHotelCalendar: _propTypes.default.bool
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    dateFormatData: _constant2.DEFAULT_DATEFORMATDATA,
    confirmLabel: _constant2.DEFAULT_CONFIRM_LABEL,
    resetLabel: _constant2.DEFAULT_RESET_LABEL,
    lowestFareLabel: _constant2.DEFAULT_FOOTER_LABEL,
    noFareLabel: _constant2.DEFAULT_NO_FARE_LABEL,
    isFareLoaded: false,
    isPartialHotelCalendar: false
  }
};
exports.default = _default;